module.exports = __webpack_public_path__ + "img/timo_honing.e7c4d8f3.jpg";